export default __webpack_public_path__ + "static/media/1128040325514030.dc23bb74.jpg";